import gql from 'graphql-tag';

import { PhotoThumbnailsPhoto } from './photo';
import { UserDetails } from './account';

export const RosterIdentityLinkedIdentityAddressFields = gql`
  fragment RosterIdentityLinkedIdentityAddressFields on RosterIdentityLinkedIdentityAddress {
    id
    name
    address_line_1
    address_line_2
    city
    state
    post_code
    country {
      id
      name
    }
    soft_deleted
  }
`;

export const RosterIdentityLinkedIdentityDetails = gql`
  fragment RosterIdentityLinkedIdentityDetails on RosterIdentityLinkedIdentity {
    id
    account {
      id
      ...UserDetails
    }
    phone_number
    addresses {
      records {
        ...RosterIdentityLinkedIdentityAddressFields
      }
    }
    identity {
      id
      current_photo {
        id
        ...PhotoThumbnailsPhoto
      }
    }
  }

  ${PhotoThumbnailsPhoto}
  ${UserDetails}
  ${RosterIdentityLinkedIdentityAddressFields}
`;

export const RosterIdentityBaseDetails = gql`
  fragment RosterIdentityBaseDetails on RosterIdentity {
    id
    first_name
    last_name
    date_of_birth
    selfie_photo {
      id
      ...PhotoThumbnailsPhoto
    }
    linked_identities(slice: { limit: 10 }) {
      records {
        id
        ...RosterIdentityLinkedIdentityDetails
      }
    }
    photos {
      matched_photos {
        total
      }
    }
    photo_share_blocked
  }
  ${PhotoThumbnailsPhoto}
  ${RosterIdentityLinkedIdentityDetails}
`;
